import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { pagoEffectivo, checkoutStepSix } from '@/pixel/pixel.js';
import { usePaypal } from './usePaypal';

export const usePaymentMethod = () => {
  const store = useStore();
  const router = useRouter();
  const { initPayPalButton } = usePaypal();

  const paymentMethod = ref('');
  const isSuccessPaymentEffectivo = ref(false);
  const barCodeReference = ref({ dataObj: { sms: null } });
  const showEffectivo = ref(true);
  const tagImage = ref('');

  const stage = process.env.VUE_APP_STAGE;
  const url = window.location.protocol + '//' + window.location.host + (stage ? `/${stage}` : '') + '/resumen';

  const checkEffectivo = async () => {
    const x = await store.dispatch('getSuscriptionEfective');
    showEffectivo.value = !!x;
  };

  const setEfectivoControls = async () => {
    pagoEffectivo.tag();
    pagoEffectivo.floodlight();
    tagImage.value = pagoEffectivo.image;
    if (Object.keys(store.state.Subscription.register_method).length === 0) {
      await store.dispatch('generateBarcode');
      await store.dispatch('getSuscriptionEfective');
    }
  };

  const setDatalayer = () => {
    const product = store.state.Products.selected;
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'add_payment_info',
        ecommerce: {
          detail: {
            products: {
              name: product.name,
              price: product.price,
              id: product.erp_id,
            },
          },
        },
      });
    }
    checkoutStepSix.tag();
    checkoutStepSix.floodlight();
    tagImage.value = checkoutStepSix.image;
  };

  const onSubmit = async (data) => {
    if (paymentMethod.value === 'paypal') {
      await store.dispatch('setRegisterMethod', { paymentMethod: 'paypal' });
      await store.dispatch('sendStatusShipping');
      await store.dispatch('sendShipping');
      router.push('/resumen');
    } else if (paymentMethod.value === 'telmex') {
      await store.dispatch('validateTelmex', data);
      const error = store.getters.getError;
      if (!error) {
        await store.dispatch('setRegisterMethod', data);
        router.push('/resumen');
      }
    } else if (paymentMethod.value === 'efectivo') {
      await store.dispatch('setRegisterMethod', { paymentMethod: 'efectivo' });
      await store.dispatch('sendShipping');
      await store.dispatch('sendReferencePayment');
      const error = store.getters.getError;
      if (!error) {
        barCodeReference.value = store.state.Subscription.barcode_sms_reference;
        isSuccessPaymentEffectivo.value = true;
      }
    }
  };

  const onCloseModalEfectivo = () => {
    isSuccessPaymentEffectivo.value = false;
  };

  const onCloseSubscriptionError = () => {
    store.commit('SET_ERROR_SUBSCRIPTION', '');
  };

  watch(paymentMethod, async (val) => {
    store.commit('SET_PAYMENT_METHOD', val);
    if (val === 'efectivo') {
      await setEfectivoControls();
    } else if (val === 'paypal') {
      await checkEffectivo();
      await initPayPalButton();
    }
  });

  checkEffectivo();
  setDatalayer();

  return {
    paymentMethod,
    isSuccessPaymentEffectivo,
    barCodeReference,
    showEffectivo,
    tagImage,
    url,
    onSubmit,
    onCloseModalEfectivo,
    onCloseSubscriptionError
  };
};
